// extracted by mini-css-extract-plugin
module.exports = {"intro":"Intro_intro__b52rV","detail":"Intro_detail__E_jso","intro__content":"Intro_intro__content__zrHuF","headline":"Intro_headline__b4Fow","body":"Intro_body__FxYE1"};